<template>
  <z-form ref="form-number" class="z-card form-number" @submit.native.prevent="submit">
    <h4>{{ $t('pbx.phone-list.form.title.edit.add_phone') }}</h4>

    <div class="z-card__body">
      <z-form-group class="row">
        <div class="col-2 text-right">{{ $t('pbx.phone-list.form.field.phone') }}</div>
        <z-form-input class="col-10" mode="input" :rules="{  max: 32 }">
          <template slot-scope="{ valid }">
            <digits-input v-model="number" />
            <icon v-if="number && valid" v-bind="icon" @click="submit" />
          </template>
        </z-form-input>
      </z-form-group>

      <div class="row">
        <div class="col-md-10 offset-2">
          <changes />
        </div>
      </div>
    </div>
  </z-form>
</template>

<script>
  import DigitsInput from '@shared/components/input/input-digit-only';
  import Changes from './changes';
  import { blue } from '@shared/helpers/css';
  import { mapActions } from 'vuex';

  export default {
    components: {
      DigitsInput,
      Changes
    },

    data() {
      return {
        number: '',

        icon: {
          color: blue,
          type: 'md-add',
          size: '24',
          class: 'form-number__submit'
        }
      };
    },
    methods: {
      ...mapActions('pbx/phone-lists/form/table', ['addPhone']),

      submit(e) {
        e.preventDefault();
        this.$refs['form-number'].validate().then((is_valid) => {
          if (is_valid && !!this.number?.trim()) {
            this.addPhone(this.number).then(() => {
              this.number = '';
              this.$refs['form-number'].reset();
            });
          }
        });
      }
    }
  };
</script>

<style lang="scss">
  .form-number {
    &__submit {
      position: absolute;
      right: calc(#{$spacer} + 4px);
      top: 4px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
